var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select2',{attrs:{"options":_vm.sortListForSelect2,"settings":{ width: '150px', minimumResultsForSearch: -1 }},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}})
}
var staticRenderFns = []

export { render, staticRenderFns }